import BaseModel from '../../../../base/base_model';
import {WEB_VIEW_TYPES, WIDGET_TYPES} from './web_view_manager_consts';
import Device from '../../../../utils/device/device';
import MasterWebView from './master_web_view';
import SecondWebView from './second_web_view';
import SafariWebView from './safari_web_view';
import {WEB_VIEW_INFO, WEB_VIEW_IDS, DEVICE_SHIFTS, WINDOW_ELEMENTS} from './web_view_manager_consts';
import _ from '../../../../utils/underscore';
import {KEY_NAME} from '../../native/native_const';
import ServiceFactory from "../../../service_factory";
import {HYBRID_EMBEDDED_NAV_MENU} from "../../../../../../app-react/components/bottom-navigation-bar/bottom-navigation-bar-consts";




class WebViewManager extends BaseModel {

    static CLASS = 'WebViewManager';

    _isFeatureGameEnable = false;
    _isFeatureCasheirEnable = false;
    _ListWebViews = [];

    _displayHybridTimeout = -1;
    _frameOffsetTopGameDemoY = 0;
    _frameOffsetTopGameY = 0;
    _frameGameRealPortrate = 0;
    _frameGameDemoPortrate = 0;
    _frameOffsetTopSportY = 0;
    _frameOffsetTopSportPortrateY = 0;
    _frameOffsetTopSportPortrate = 0;
    _frameOffsetTopLandScapeY = null;
    _frameOffsetTopPortrateY = null;
    _frameOffsetTopPortrateIphoneX = null;
    _frameOffsetTopCashierY = 0;
    _frameOffsetBottomCashierY = 0;
    _displayGameTimeOut = 0;
    _butInitGame = false;
    _butInitCashier = false;
    _butInitSport = 'false';
    _butRtl = true;
    _butW = 0;
    _butH = 0;
    _butX = 0;
    _butY = 0;
    _but_landscape_x = 0;
    _but_landscape_y = 0;
    _nLocalHostPort = 0;
    _allHtmlCompiledGames = '';
    _ndpToPx = 1;


    init(params) {

        this._initParams(params);

        super.init(params);
    }

    _initParams(params) {

        if (Device.hybrid.isHybrid) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if(undefined === params){
            return;
        }


        this._isFeatureGameEnable = 'true' === params.enable_game;
        this._isFeatureCasheirEnable = 'true' === params.enable_casheir;
        this._displayHybridTimeout = params.display_hybrid_timeout;

        if (this._isFeatureGameEnable || this._isFeatureCasheirEnable) {
            this._displayGameTimeOut = params.display_game_time_out;
            this._frameOffsetTopGameDemoY = params.frame_offset_top_game_demo_y;
            this._frameOffsetTopGameY = params.frame_offset_top_game_real_y;
            this._frameGameRealPortrate = params.game_r_portrate;
            this._frameGameDemoPortrate = params.game_d_portrate;
            this._frameOffsetTopSportPortrateY = params.game_sport_portrate;
            this._frameOffsetTopSportY = params.frame_offset_top_sport_y;

            this._frameOffsetTopLandScapeY = params.iphoneXtopLandScapeY;
            if(Device.isIphoneX()) {
                this._frameOffsetTopPortrateIphoneX = params.iphoneXtopPortrateY;
            } else {
                this._frameOffsetTopPortrateY = params.iphonetopPortrateY;
            }
            this._frameOffsetTopCashierY = params.frame_offset_top_cashier_y;
            this._frameOffsetBottomCashierY = params.frame_offset_bottom_cashier_y;
            this._butInitSport = params.but_initSport;
            this._butInitGame = params.but_initGame;
            this._butInitCashier = params.but_initCashier;
            this._butRtl = params.but_rtl;

            if(Device.isIphoneX() && undefined !== params.iphonex) {
                params = params.iphonex;
                this._but_landscape_x = params.but_landscape_x;
                this._but_landscape_y = params.but_landscape_y;
            }

            this._butW = params.but_w;
            this._butH = params.but_h;
            this._butX = params.but_x;
            this._butY = params.but_y;
        }
    }

    getDisplayHybridTimeout() {
        return this._displayHybridTimeout;
    }
    /**
     * is Feature Game Enable
     * return true if enable
     */
    isFeatureGameEnable() {
        return this._isFeatureGameEnable;
    }

    /**
     * disable the Feature Game
     */
    setFeatureGameDisable() {
        this._isFeatureGameEnable = false;
    }

    /**
     * is Feature Casheir Enable
     * return true if enable
     */
    isFeatureCasheirEnable() {
        return this._isFeatureCasheirEnable;
    }

    /**
     * init the WebView
     * type exmmple open game: 1
     * id exmmple open game: 1
     */
    initWebView(type, id, parent) {

        let webview = null;

        let params = {
            'id': id,
            'type': type,
            'parent': parent
        };

        switch (type) {
            case WEB_VIEW_TYPES.MASTER:
                webview = MasterWebView.create(params);
                break;
            case WEB_VIEW_TYPES.SECOND:
                webview = SecondWebView.create(params);
                break;
            case WEB_VIEW_TYPES.SAFARI:
                webview = SafariWebView.create(params);
                break;
            default:
                // maybe should throw an Exception here
                break;
        }

        return this._addToList(webview);
    }

    /**
     * remove the webView
     * webview: to be removed
     */
    remove(webview) {
        let id = webview.getWebId();
        for (let index = 0; index < this._ListWebViews.length; index++) {
            if (id === this._ListWebViews[index].getWebId()) {
                this._ListWebViews.splice(index, 1);
                webview = null;
                return;
            }
        }
    }

    /**
     * add To List of all WebViews
     * webview: to be added
     */
    _addToList(webview) {

        if (this._isValid(webview)) {
            this._ListWebViews.push(webview);
        } else {
            webview = null;
        }

        return webview;

        //  alert('Id: ' + webview.getWebId() + ' Type: ' + webview.getType());
    }

    /**
     * is Valid - check if the VebView is valid, if not already exist and the type + id are in range
     * webview: to be checked
     */
    _isValid(webview) {
        if (null !== webview && !this._isAlreadyExist(webview) && webview.isValidId()) {
            return true;
        }

        return false;
    }

    /**
     * get all Open webViews - get the list of all WebViews
     * return allWebViews list
     */
    getallOpenwebViews() {

        let allWebViews = [];
        for (let ii = 0; ii < this._ListWebViews.length; ii++) {
            if (0 !== this._ListWebViews[ii].getWebId()) {
                allWebViews.push(this._ListWebViews[ii]);
            }
        }

        return allWebViews;
    }

    /**
     * is Already Exist - check if the WebView already exist in list
     * webview - to be checked
     * return bool
     */
    _isAlreadyExist(webview) {

        let newId = webview.getWebId();

        for (let ii = 0; ii < this._ListWebViews.length; ii++) {
            if (newId === this._ListWebViews[ii].getWebId()) {
                return true;
            }
        }

        return false;
    }

    /**
     * get WebView By Id - find the WebView by his id
     * id: the webView id
     * return webview
     */
    getWebViewById(id) {

        for (let ii = 0; ii < this._ListWebViews.length; ii++) {
            if (id === this._ListWebViews[ii].getWebId()) {
                return this._ListWebViews[ii];
            }
        }

        return null;
    }

    /**
     * fill Widget - add the Widget relevant info
     * obj: object with general info
     * return obj
     */
    filWidgetInfo(obj,bShowCloseBut, widgetType) {

        obj[WEB_VIEW_INFO.TYPE] = WEB_VIEW_TYPES.SECOND;
        obj[WEB_VIEW_INFO.ID] = WEB_VIEW_IDS.DEPOSIT_WIDGET_ID;

        if(bShowCloseBut) {
            obj[WEB_VIEW_INFO.BUT_INIT] = this._butInitGame;
            obj = this._fillCloseButInfo(obj, widgetType);
        }
        return obj;
    }

    /**
     * fill Cashier Info - add the casheir relevant info
     * obj: object with general info
     * return obj
     */
    fillCashierInfo(obj) {

        obj[WEB_VIEW_INFO.FRAME_OFFSET_TOP_Y] = this._frameOffsetTopCashierY;
        obj[WEB_VIEW_INFO.FRAME_OFFSET_BOTTOM_Y] = this._frameOffsetBottomCashierY;
        obj[WEB_VIEW_INFO.TYPE] = WEB_VIEW_TYPES.SAFARI;
        obj[WEB_VIEW_INFO.ID] = WEB_VIEW_IDS.SAFARI_ID;
        obj[WEB_VIEW_INFO.BUT_INIT] = this._butInitCashier;
        obj = this._fillCloseButInfo(obj,WIDGET_TYPES.DEPOSIT);

        return obj;
    }

    /**
     * fill game Info - add the game relevant info
     * obj: object with general info
     * gameTimeOut: ovverite the curent display game timeout
     * return obj
     */
    fillGameInfo(obj, gameTimeOut) {
        let bReal = ServiceFactory.create().oAuth2Service().isAuthorized();
        obj[WEB_VIEW_INFO.FRAME_OFFSET_TOP_Y] = bReal ? this._frameOffsetTopGameY : this._frameOffsetTopGameDemoY;
        obj[WEB_VIEW_INFO.FRAME_OFFSET_TOP_PORTRATE_Y] = bReal ? this._frameGameRealPortrate : this._frameGameDemoPortrate;
        obj[WEB_VIEW_INFO.TYPE] = WEB_VIEW_TYPES.SECOND;
        obj[WEB_VIEW_INFO.ID] = this._getNextGameId();
        obj[WEB_VIEW_INFO.TAP_KEEP_ALIVE] = 'true';
        obj[WEB_VIEW_INFO.BUT_INIT] = this._butInitGame;
        obj[WEB_VIEW_INFO.DISPLAY_GAME_TIME_OUT] = undefined !== gameTimeOut ? gameTimeOut : this._displayGameTimeOut;
        obj = this._fillGTValues(obj);
        obj = this._fillCloseButInfo(obj,WIDGET_TYPES.GAME);

        return obj;
    }

    _fillGTValues(obj){

        obj[WEB_VIEW_INFO.FRAME_TOP_LANDSCAPE_Y] = this._frameOffsetTopLandScapeY;
        obj[WEB_VIEW_INFO.FRAME_TOP_PORTRATE_Y] = this._frameOffsetTopPortrateY;
        obj[WEB_VIEW_INFO.FRAME_TOP_PORTRATE_IPHONE_X] = this._frameOffsetTopPortrateIphoneX;

        return obj;
    }

    fillSportInfo(obj) {
        obj[WEB_VIEW_INFO.REMOTE_URL] = 'true';
        obj[WEB_VIEW_INFO.WINDOW_ELEMENT] = WINDOW_ELEMENTS.SPORT;
        obj[WEB_VIEW_INFO.TYPE] = WEB_VIEW_TYPES.SECOND;
        obj[WEB_VIEW_INFO.ID] = this._getNextGameId();
        obj[WEB_VIEW_INFO.BUT_INIT] = this._butInitSport;

        return obj;
    }

    getEmbeddedNavMenuHeight(){
        const bottomMenu = document.querySelector(`.${HYBRID_EMBEDDED_NAV_MENU}`);
        const offsetHeight = bottomMenu ? bottomMenu.offsetHeight : DEVICE_SHIFTS.IPHONE_DEFAULT;

        return offsetHeight;
    }

    addSportCommonInfo(obj){
        obj[WEB_VIEW_INFO.SHIFT_FROM_BOTTOM] = this.getEmbeddedNavMenuHeight() * this._ndpToPx;

        return obj;
    }

    _addSpecificDeviceAdaptations(obj){

        if(DEVICE_SHIFTS.ANDROID_S9_HEIGHT === window.innerHeight && DEVICE_SHIFTS.ANDROID_S9_WIDTH === window.innerWidth){//android s9
            switch(this._ndpToPx){
                case DEVICE_SHIFTS.ANDROID_S9_DENSITY_2:
                    obj[WEB_VIEW_INFO.ANDROID_PORTRATE_NAV_BAR_DISPLAY] = DEVICE_SHIFTS.ANDROID_S9_DP_2;
                break;
                case DEVICE_SHIFTS.ANDROID_S9_DENSITY_4:
                    obj[WEB_VIEW_INFO.ANDROID_PORTRATE_NAV_BAR_DISPLAY] = DEVICE_SHIFTS.ANDROID_S9_DP_4;
                break;
                default:
            }
        } else if(DEVICE_SHIFTS.ANDROID_S9_HEIGHT === window.innerWidth && DEVICE_SHIFTS.ANDROID_S9_WIDTH === window.innerHeight){
            obj[WEB_VIEW_INFO.ANDROID_LANDSCAPE] = DEVICE_SHIFTS.ANDROID_S9_LANDSCAPE;
        }

        return obj;
    }

    addAndroidInfo(obj) {

        obj[WEB_VIEW_INFO.ANDROID_PORTRATE] = DEVICE_SHIFTS.ANDROID_DEFAULT;
        obj[WEB_VIEW_INFO.ANDROID_LANDSCAPE] = DEVICE_SHIFTS.ANDROID_DEFAULT;
        obj[WEB_VIEW_INFO.ANDROID_PORTRATE_NAV_BAR_DISPLAY] = DEVICE_SHIFTS.ANDROID_PORTRATE_NAV_BAR_DISPLAY;
        obj[WEB_VIEW_INFO.ANDROID_PORTRATE_NAV_BAR_NOT_DISPLAY] = DEVICE_SHIFTS.ANDROID_PORTRATE_NAV_BAR_NOT_DISPLAY;

        obj = this._addSpecificDeviceAdaptations(obj);

        return this.addSportCommonInfo(obj);
  }

    addIosInfo(obj){
        obj = this.addSportCommonInfo(obj);
        obj[WEB_VIEW_INFO.IPHONE_X_PORTRATE] = DEVICE_SHIFTS.IPHONE_X_PORTRATE;
        obj[WEB_VIEW_INFO.IPHONE_X_LANDSCAPE] = DEVICE_SHIFTS.IPHONE_X_LANDSCAPE;
        obj[WEB_VIEW_INFO.IPHONE_X_12_PRO_LANDSCAPE] = DEVICE_SHIFTS.IPHONE_X_12_PRO_LANDSCAPE;

        return obj;
    }

    fillSportInfoInSecondWebView(obj) {
        obj = this.fillSportInfo(obj);

        if(Device.os.isIOS) {
            obj = this.addIosInfo(obj);
        }else if(Device.os.isAndroid){
            obj = this.addAndroidInfo(obj);
            obj[WEB_VIEW_INFO.BUT_X] = DEVICE_SHIFTS.ANDROID_X_BUTL;
        }

        return obj;
    }

    /**
     * fill Close But Info - add the Close But relevant info
     * obj: object with general info
     * return obj
     */
    _fillCloseButInfo(obj, widgetType) {

        obj[WEB_VIEW_INFO.BUT_RTL] = this._butRtl;
        obj[WEB_VIEW_INFO.BUT_W] = this._butW;
        obj[WEB_VIEW_INFO.BUT_H] = this._butH;
        obj[WEB_VIEW_INFO.BUT_X] = this._butX;
        obj[WEB_VIEW_INFO.BUT_Y] = this._butY;
        obj[WEB_VIEW_INFO.BUT_LANDSCARE_X] = this._but_landscape_x;
        obj[WEB_VIEW_INFO.BUT_LANDSCARE_Y] = this._but_landscape_y;

        if (WIDGET_TYPES.SPID === widgetType) {
            obj[WEB_VIEW_INFO.BUT_W] = 32;
            obj[WEB_VIEW_INFO.BUT_H] = 32;
            obj[WEB_VIEW_INFO.BUT_X] = 0;
            obj[WEB_VIEW_INFO.BUT_Y] = 0;
            obj[WEB_VIEW_INFO.BUT_LANDSCARE_X] = 20;
            obj[WEB_VIEW_INFO.BUT_LANDSCARE_Y] = 3;
        }

        return obj;
    }

    /**
     * get Next Game Id: look for the next free game id
     * return next Id
     */
    _getNextGameId() {
        let nWebId, nextId = WEB_VIEW_IDS.GAME_ID;

        for (let ii = 0; ii < this._ListWebViews.length; ii++) {
            if ( this._ListWebViews[ii].getType() === WEB_VIEW_TYPES.SECOND) {
                nWebId = this._ListWebViews[ii].getWebId();
                nextId = Math.max(nextId, nWebId + 1);
            }
        }
        return nextId;
    }

    getDpToPx(data, dpToPx) {

        data = _.safeJSONandDecode(data);

        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return dpToPx;
        }

        let keyData = data[KEY_NAME.DATA];
        if (undefined !== keyData) {
            dpToPx = keyData[KEY_NAME.DP_TO_PX];
        }

        this._ndpToPx = dpToPx;

        return dpToPx;
    }

    getCompiledGamesList(data) {
        data = _.safeJSONandDecode(data);

        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return '';
        }

        let keyData = data[KEY_NAME.DATA];
        if (undefined !== keyData) {

            let allHtmlCompiledGames = keyData[KEY_NAME.MSG];
            if (allHtmlCompiledGames.length > 0) {
                this._nLocalHostPort = keyData[KEY_NAME.PORT];
            }
            return allHtmlCompiledGames;
        }

        return '';
    }

    getLocalHostPortPort() {
        return this._nLocalHostPort;
    }
}

export default WebViewManager;
